import { Typography } from "@material-ui/core"

export const OwnerMissing = ({ metaData }) => {

    return <>
        <Typography><strong>Step 1:</strong> Go to the <strong>Buildings</strong> menu.</Typography>
        <Typography><strong>Step 2:</strong> Select the building named <strong>{metaData?.Name}</strong>.</Typography>
        <Typography><strong>Step 3:</strong> Open the <strong>Owner</strong> tab.</Typography>
        <Typography><strong>Step 4:</strong> Click <strong>Add</strong> to create a new owner for this building.</Typography>
    </>
}